﻿import controller from '../../../../resources/scripts/_shared/controller';

function caseContainerBlock(context) {
	const caseCategories = [];
	const caseCategoriesWrapper = context.querySelector('.case-list__categories');
	const caseButtons = Array.prototype.slice.call(context.querySelectorAll('.case-list__buttons'));
	const caseItemsContainer = context.querySelector('.case-list__items');
	const caseItems = caseItemsContainer.children;
	//const uA = navigator.userAgent;
	//const isSafariDesktop = /Safari/i.test(uA) && !/Mobi|Android/i.test(uA);
	let scrollTimer = null;
	let lastScroll = 0;

	let selectedCaseFilters = [];
	function setItemsCategories() {
		const caseItemsArr = [...caseItems];
		caseItemsArr.map((item, index) => {
			if (!item.dataset.categories) return
			const allCategories = JSON.parse(item.dataset.categories.replace(/'/g, '\"'));

			allCategories.map(singleCategory => {
				const categoryName = singleCategory[0];
				const categoryNameKebab = singleCategory[1];
				const categoryId = singleCategory[2];

				const exists = caseCategories.filter(existingCaseCategory => existingCaseCategory.categoryId === categoryId).length > 0;

				if (!exists) {
					caseCategories.push({
						categoryName,
						categoryNameKebab,
						categoryId,
					});
				} 
			})
		})
		addItemsToWrapper();
	}

	const setFirstAndLastItem = () => { 
		if (caseButtons.length === 0) return;
		caseItems[0].classList.add('first');
		caseItems[caseItems.length-1].classList.add('last');
	}

	function addItemsToWrapper() {
		if (caseCategories.length > 0) caseCategoriesWrapper.style.display = 'flex';
		else return;

		caseCategories.map(singleCategory => {
			const btn = document.createElement('LI');

			btn.innerHTML = singleCategory.categoryName;
			btn.setAttribute('id', singleCategory.categoryId);
			btn.setAttribute('data-kebab', singleCategory.categoryNameKebab);
			btn.classList.add('case-list__category');

			caseCategoriesWrapper.appendChild(btn);
		})
	}

	function handleClickEvent(event) {
		const target = event.target;
		if (target.tagName === 'LI') {
			target.classList.toggle('case-list__category--selected');

			selectedCaseFilters.length = 0;

			const currentCategorySelection = caseCategoriesWrapper.querySelectorAll('li.case-list__category--selected');
			selectedCaseFilters = [...currentCategorySelection].map(item => parseInt(item.id));
			
			if (caseCategories.length === selectedCaseFilters.length) {
				[...caseItems].map(item => item.classList.remove('hide'));
				return;
			}

			[...caseItems].map(item => {
				const itemCategories = JSON.parse(item.dataset.categories.replace(/'/g, '\"'));
				itemCategories.map(category => item.classList.toggle('hide', selectedCaseFilters.includes(category[2])));
			})
		}
	}

	function handleButtonClickEvent(event) {
		const visibleElements = checkVisible();
		const direction = event.target.classList.contains('case-list__leftbutton') ? 'left' : 'right';
		scrollToElement(direction === 'left' ? getPrevElement(visibleElements) : getNextElement(visibleElements));
	} 

	const getPrevElement = (list) => {
		if (!list.length) return null
		const sibling = list[0].previousElementSibling;
		if (sibling instanceof HTMLElement && window.innerWidth > 1164) return sibling.nextElementSibling;
		else if (sibling instanceof HTMLElement) return sibling;
		return null;
	}

	const getNextElement = (list) => {
		if (!list.length) return null
		const sibling = list[list.length - 1].nextElementSibling;
		if (sibling instanceof HTMLElement && window.innerWidth > 1164) return sibling.previousElementSibling;
		else if (sibling instanceof HTMLElement) return sibling;
		return null;
	}

	const checkVisible = () => {
		const rect = caseItemsContainer.getBoundingClientRect();
		const visibleElements = Array.from(caseItems).filter((item) => {
			const itemRect = item.getBoundingClientRect();
			return (rect.left - 20) <= (itemRect.left + 1) && (rect.right + 20) >= (itemRect.right - 1);
		})
		return visibleElements;
	}

	const scrollToElement = (element) => {
		if (!element) return;
		let newScrollPosition = element.offsetLeft + element.getBoundingClientRect().width / 2 - caseItemsContainer.getBoundingClientRect().width / 2;
		caseItemsContainer.scroll({
			left: Math.round(newScrollPosition),
			behavior: 'smooth',
		});
	}

	const handleButtons = () => {
		const visibleElements = checkVisible();
		if (!visibleElements.length) return;
		if (visibleElements && visibleElements.length === caseItems.length) caseButtons.forEach(button => button.style.display = "none");
		else caseButtons.forEach(button => button.style.display = "block");
    if (visibleElements[visibleElements.length - 1].classList.contains('last'))
      caseButtons[1].setAttribute('disabled', 'disabled');
    else caseButtons[1].removeAttribute('disabled');
		if (visibleElements[0].classList.contains('first'))
			caseButtons[0].setAttribute('disabled', 'disabled');
    else caseButtons[0].removeAttribute('disabled');
  }
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	function init() {
		setItemsCategories();
		setFirstAndLastItem();
		handleButtons();
		if (caseCategoriesWrapper) caseCategoriesWrapper.addEventListener('click', handleClickEvent);
		caseItemsContainer.addEventListener('scroll', debounceScroll);
		caseButtons.forEach(button => button.addEventListener('click', handleButtonClickEvent))
		window.addEventListener('resize', debounceResize);
	}

	const debounceScroll = debounce(handleButtons, 50);
	const debounceResize = debounce(handleButtons, 500);

	return {
		init
	};
}

controller.add('case-list-block', caseContainerBlock);